import React, { useRef, useState } from "react";
import PropTypes from "prop-types";
import "./Offre.scss";
import offre1 from "assets/offre1.webp";
import iconeBuildingColor from "assets/iconeBuildingColor.png";
import iconeLaurierColor from "assets/iconeLaurierColor.png";
// import img_groupe1 from "assets/logoOffre1.webp";
// import diffuseur_logo from "assets/diffuseur_logo.png";
import { Link, useLocation } from "react-router-dom";
import {
  FaSuitcase,
  FaMapMarkerAlt,
  FaUsers,
  FaBookmark,
  FaRegBookmark,
  FaWheelchair,
  // FaRegStar,
} from "react-icons/fa";
import { formatDate, formatContrat, truncate } from "Services/functions";
import { updateAuth } from "Redux/Actions/authActions";
import { connect } from "react-redux";
import Loader from "Components/Loader/loader";
import axios from "axios";
import { Toast } from "primereact/toast";

const API_LINK = process.env.REACT_APP_BASE_URL_API.split("/api")[0];

const Offre = (props) => {
  const uploadToast = useRef(null);
  const cancelToast = useRef(null);
  var bookmark =
      props.bookmark ||
      props.auth.userConnected?.savedOffers.some(
          (offer) => offer.id === props.offreDetails.id
      );

  const [isLoader, setIsLoader] = useState(false);
  const addOfferToSaveList = () => {
    const url = `${process.env.REACT_APP_BASE_URL_API}/offers/${props.offreDetails.id}/save`;
    const data = { savedByUsers: [`api/users/${props.auth.userConnected.id}`] };
    setIsLoader(true);
    axios
        .post(url, data, {
          headers: props.auth.token
              ? {
                accept: "application/json",
                Authorization: `Bearer ${props.auth.token}`,
              }
              : {
                accept: "application/json",
              },
        })
        .then((res) => {
          setIsLoader(false);
          let user = props.auth.userConnected;
          user.savedOffers = user.savedOffers.concat(res.data);
          props.handleAuth({
            userConnected: user,
          });
          uploadToast.current.show({
            severity: "success",
            summary: "Succès : ",
            detail: "L'offre a bien été ajoutée aux offres sauvegardées",
            life: 3000,
          });
        })
        .catch((error) => {
          console.log("Error modify : ", error.response);
        });
  };
  const removeOfferFromSaveList = () => {
    const url = `${process.env.REACT_APP_BASE_URL_API}/offers/${props.offreDetails.id}/erase`;
    const data = { savedByUsers: [`api/users/${props.auth.userConnected.id}`] };
    setIsLoader(true);
    axios
        .post(url, data, {
          headers: props.auth.token
              ? {
                accept: "application/json",
                Authorization: `Bearer ${props.auth.token}`,
              }
              : {
                accept: "application/json",
              },
        })
        .then((res) => {
          setIsLoader(false);
          let user = props.auth.userConnected;
          (user.savedOffers = user.savedOffers.filter(
              (saved) => saved.id !== res.data.id
          )),
              props.handleAuth({
                userConnected: user,
              });
          cancelToast.current.show({
            severity: "error",
            summary: "succès : ",
            detail: "L'offre a bien été retirée des offres sauvegardées",
            life: 3000,
          });
        })
        .catch((error) => {
          console.log("Error modify : ", error);
        });
  };

  return (
      <div
          className={
            useLocation().pathname == "/" ||
            useLocation().pathname == "/profil" ||
            useLocation().pathname == "/offres" ||
            useLocation().pathname == "/depot-offre" ||
            useLocation().pathname == "/gestion-offre"
                ? "offre cardHover"
                : "offre"
          }
          onClick={() => props.onClick && props.onClick()}
      >
        <Toast ref={uploadToast} />
        <Toast ref={cancelToast} />
        <Link
            to={{
              pathname: props.auth.isConnected
                  ? `/offre-detail/${props.offreDetails.id}`
                  : "/offres",
              params: props.offreDetails.id,
            }}
        >
          <div className="offre__image">
            <div className="offre__image__header">
              {props.url == "img1" ? (
                  <>
                    <img src={offre1} alt="Fond offre" />
                    <div
                        className="image__bg"
                        style={{ backgroundImage: `url(${offre1})` }}
                    ></div>
                  </>
              ) : (
                  <>
                    <img
                        src={props.url}
                        alt="logo"
                        onError={(e) => {
                          e.target.src = offre1;
                        }}
                    />
                    <div
                        className="image__bg"
                        style={{
                          backgroundImage: `url(${props.url})`,
                        }}
                    ></div>
                  </>
              )}
            </div>
            {props.offreDetails?.transmitter?.name === "Recruteur" ? (
                <div className="offre__image__logo_univ">
                  <img
                      src={
                        props.logoEntreprise
                            ? props.logoEntreprise
                            : API_LINK +
                            (props.offreDetails.company?.logoLink ||
                                props.offreDetails.university
                                    ?.imageTransparentAndColorUrl)
                      }
                      alt="Logo entreprise"
                      title="Logo entreprise"
                  />
                </div>
            ) : props.offreDetails?.transmitter?.name === "Diffuseur" ? (
                <div className="offre__image__logo">
                  <img
                      src={
                        props.secondaryTables.transmittersData.filter(
                            (picture) => picture.name === "Diffuseur"
                        )[0]?.imageUrl
                      }
                      alt="Logo entreprise"
                      title="Logo entreprise"
                  />
                </div>
            ) : props.offreDetails?.transmitter?.name === "Alumni" ? (
                <div className="offre__image__logo">
                  <img
                      src={
                        props.secondaryTables.transmittersData.filter(
                            (picture) => picture.name === "Alumni"
                        )[0]?.imageUrl
                      }
                      alt="Logo entreprise"
                      title="Logo entreprise"
                  />
                </div>
            ) : (
                <div className="offre__image__logo">
                  <img
                      src={
                        props.secondaryTables.transmittersData.filter(
                            (picture) => picture.name === "Admin"
                        )[0]?.imageUrl
                      }
                      alt="Logo entreprise"
                      title="Logo entreprise"
                  />
                </div>
            )}
          </div>
        </Link>

        <Link
            to={{
              pathname: props.auth.isConnected
                  ? `/offre-detail/${props.offreDetails.id}`
                  : "/offres",
              params: props.offreDetails.id,
            }}
        >
          <div className="offre__container">
            <div className="offre__container__description">
              <div className="offre__container__description__title">
              <span>
                {props.offreDetails.title &&
                    truncate(props.offreDetails.title, 25)}
              </span>
              </div>
              <div className="offre__container__description__statut">
                <FaSuitcase />
                {props.offreDetails.typeOfContract ? (
                    <span>
                  {formatContrat(props.offreDetails.typeOfContract.label)}
                </span>
                ) : (
                    <span>{props.offreDetails.offerCategory?.label}</span>
                )}
              </div>
              <div className="offre__container__description__statut">
                <FaMapMarkerAlt />
                <span>
                {props.offreDetails.city} (
                  {props.offreDetails.country &&
                      truncate(props.offreDetails.country, 3)}
                  )
              </span>
              </div>
              <div className="offre__container__description__statut">
                <FaUsers />
                {props.offreDetails.company ? (
                    <span>{props.offreDetails.company?.totalStaff?.label}</span>
                ) : (
                    <span>Non renseigné</span>
                )}
              </div>
              <div className="offre__container__ description__handicap">
                {props.accessibleForDisabled && (
                    <div className="offre__container__description__handicap__icon">
                      <FaWheelchair />
                      <span>Handi-accueillant</span>
                    </div>
                )}
              </div>
              <div
                  className="offre__categorie"
                  style={{
                    marginTop: props.accessibleForDisabled ? "0rem" : "2.5rem",
                  }}
              >
                {props.offreDetails.company &&
                props.offreDetails.company.isPartner ? (
                    <span className="offre__categorie__entreprise">
                  <img src={iconeBuildingColor} alt="" />
                  Entreprise Partenaire
                </span>
                ) : (
                    props.offreDetails?.transmitter?.name === "Alumni" && (
                        <span className="offre__categorie__alumni">
                    <img src={iconeLaurierColor} alt="" />
                    Alumni
                  </span>
                    )
                )}
              </div>
            </div>
          </div>
        </Link>
        <div className="offre__date">
          {formatDate(props.offreDetails.modifiedAt, ".")}{" "}
          {!isLoader ? (
              bookmark ? (
                  <FaBookmark
                      onClick={() => {
                        removeOfferFromSaveList();
                      }}
                  />
              ) : (
                  <FaRegBookmark
                      onClick={() => {
                        addOfferToSaveList();
                      }}
                  />
              )
          ) : (
              <Loader></Loader>
          )}
        </div>
      </div>
  );
};

Offre.propTypes = {
  date: PropTypes.string,
  bookmark: PropTypes.bool,
  offreDetails: PropTypes.any,
  test: PropTypes.string,
  image: PropTypes.number,
  categorie: PropTypes.number,
  logoEntreprise: PropTypes.any,
  employes: PropTypes.string,
  accessibleForDisabled: PropTypes.any,
  url: PropTypes.string,
  onClick: PropTypes.func,
  auth: PropTypes.object,
  handleAuth: PropTypes.func,
  offers: PropTypes.object,
  companies: PropTypes.object,
  secondaryTables: PropTypes.object,
};

const mapStateToProps = (state) => ({
  items: state.items,
  auth: state.auth,
  offers: state.offers,
  companies: state.companies,
  secondaryTables: state.secondaryTables,
});

const mapDispatchToProps = (dispatch) => ({
  handleAuth: (value) => {
    dispatch(updateAuth(value));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Offre);
